import styled, { keyframes } from 'styled-components'

import { MediaWrapperOrientated } from './shared/MediaWrapper'
import { CardWrapper, Media, Content } from './shared/styled'

type TextRowProps = {
  length?: string
}

const TextRow = styled.div<TextRowProps>`
  display: block;
  width: 100%;
  height: 1em;
  margin-top: 0.7em;

  &:first-child {
    margin-top: 0;
  }

  &:after {
    content: ' ';
    display: inline-block;
    height: 1em;
    width: ${({ length }) => length || '100%'};
    background-color: ${({ color }) => color || '#eee'};
  }
`

const pulseAnimation = keyframes`
  0% {
    opacity: .6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: .6;
 }
`

export const PlaceholderCardWrapper = styled(CardWrapper)`
  animation: ${pulseAnimation} 1.5s infinite;
`

export const ListingContent = styled(Content)``

const PlaceholderDetails = styled.div`
  width: calc(100% / 1.61803398875);
`

const PlaceholderPrice = styled.div`
  flex: 1;
  text-align: right;
`

interface Props {
  hideRightContent?: boolean
  portrait?: boolean
}

export default ({ hideRightContent, portrait = true }: Props) => {
  return (
    <PlaceholderCardWrapper>
      <Media>
        <MediaWrapperOrientated portrait={portrait} />
      </Media>
      <Content as="div">
        <PlaceholderDetails>
          <TextRow color="#ddd" length="97%" />
          <TextRow length="50%" />
          <TextRow length="75%" />
        </PlaceholderDetails>

        {!hideRightContent && (
          <PlaceholderPrice>
            <TextRow color="#0c6776" length="3em" />
            <TextRow length="4em" />
          </PlaceholderPrice>
        )}
      </Content>
    </PlaceholderCardWrapper>
  )
}
